const MuiPickersToolbar = {
    toolbar: {
        backgroundColor: '#FFC42B',
    },
}

export default MuiPickersToolbar;
